const doc = [({"da":({"js":({"layout":({"top_nav":({"notifications_modal":({"you_have_no_unread_notifications":"Du har ikke nogen ulæste notifikationer."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;